import { AsheetLogoExcelSvg } from "../../../constants/common-svgs";
import { ASButton } from "../../../shared/as-button/as-button";
import './connect-view.scss';
import CloudParameterController from "../../../controllers/connections/cloud-parameters/cloud-parameters-controller";

const ConnectPageView = (props) => {
    const { selectedConnection, testConnection, cloudConnectionTypesParameter, extraParam, setCloudConnectionTypesParameter } = props;   

    return (
        <>
           <div className={`connect-view-div ${cloudConnectionTypesParameter ? "short-margin" : ""}`}>
                {cloudConnectionTypesParameter &&                    
                    <CloudParameterController
                        cloudConnectionTypesParameter={cloudConnectionTypesParameter}
                        plugIn={true}
                        setCloudConnectionTypesParameter={setCloudConnectionTypesParameter}
                    />
                }
                <label>
                    Connect to {selectedConnection?.description}
                </label>
                <div className="logo-div">
                    <span className="asheetlogo">{AsheetLogoExcelSvg}</span>
                    <img className="arrow-icon-div" src={`/assets/right-arrow.svg`} alt="" />
                    <img className="connection-logo" src={`/assets/${selectedConnection?.iconImage}`} alt={selectedConnection?.iconImage} />
                </div>
                <div className="connect-button-div">
                    <ASButton primary={true} disabled={extraParam} variant="contained" onClick={testConnection}> Connect </ASButton>
                </div>
            </div>
        </>
    );
}
export default ConnectPageView;